import { useEffect, useState } from "react";
import { brandName, navAnchors, trending } from "@/mocks/gossip";

const headlines = trending.slice(0, 5).map((t) => t.title);

function TopBar() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setIdx((p) => (p + 1) % headlines.length), 3200);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className="bg-foreground-950 text-background-100">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-flashlight-fill h-3 w-3"></i>
          主编热荐
        </span>
        <div className="flex h-5 flex-1 items-center overflow-hidden">
          <p key={idx} className="truncate text-xs leading-5 text-background-200 transition-all">
            {headlines[idx]}
          </p>
        </div>
        <span className="hidden shrink-0 items-center gap-1 text-xs text-accent-300 sm:flex">
          <i className="ri-fire-line h-3.5 w-3.5"></i>
          <span className="whitespace-nowrap">实时瓜田 · {new Date().toLocaleDateString("zh-CN")}</span>
        </span>
      </div>
    </div>
  );
}

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      <TopBar />
      <div
        className={`border-b transition-colors duration-300 ${
          scrolled || open
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3.5 md:px-6">
          <a href="#home" className="flex items-center gap-2" aria-label={`${brandName} 首页`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg leading-none">
              <span aria-hidden="true">🍉</span>
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              {brandName}
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navAnchors.map((a) => (
              <a
                key={a.href}
                href={a.href}
                className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {a.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 lg:flex">
            <a
              href="#contact"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-edit-2-line h-4 w-4"></i>
              投稿爆料
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-800 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line h-5 w-5" : "ri-menu-line h-5 w-5"}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <div className="grid grid-cols-2 gap-1">
              {navAnchors.map((a) => (
                <a
                  key={a.href}
                  href={a.href}
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  {a.label}
                </a>
              ))}
            </div>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-edit-2-line h-4 w-4"></i>
              投稿爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}